import { useState } from "react"
import style from "./card.module.css"
import VideogameDetail from "./VideogameDetail"

function Card({ id, name, image, rating, genres }) {
  const [modal, setModal] = useState(false)
  const handleClink = () => {
    setModal(!modal)

  }

  
  return (
    <div className={style.container}>
        
        <img src = {image} className={style.images} alt={`Representation of ${name}`}/>
        
        <h2 className={style.name}>{name}</h2>
        
        <div className={style.infor}>
          
          <div>
            {genres && genres.map(genre => (<div key={genre}>{genre}</div>))}
          </div>
          <button className={style.button} onClick={handleClink}> More</button>
          {modal ? <VideogameDetail id={id} handleClink={handleClink}/> : null}
        </div>
        
    </div>
  )
}

export default Card